import { CompanyCollectorGroupRepository } from '@domain/company-collector-group/repositories/company-collector-group.repository';
import { CompanyCollectorGroupRepositoryService } from '../repositories/company-collector-group.service';

export const CompanyCollectorGroupProvider = [
  {
    provide: CompanyCollectorGroupRepository,
    useClass: CompanyCollectorGroupRepositoryService,
  },
];
